import React from 'react'
import TextField from '@material-ui/core/TextField'
import { useForm, Controller } from 'react-hook-form'
import { EMAIL_REGEX } from '../../../Constants'
import { SkywatchDialog } from '../../PopUps/SkywatchDialog'
import FlexView from 'react-flexview/lib'
import NewFillButton from '../../Core/NewFillButton'
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail'
import { ElevatedCircle } from '../../Core/ElevatedCircle'
import {
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../../services/FirebaseService'

export const GetEmailPopup = ({
  open,
  title,
  body,
  onConfirm,
  onCancel,
  ...props
}) => {
  const { register, errors, getValues, trigger, control } = useForm()

  const handleClose = () => {
    onCancel && onCancel()
  }

  const Confirm = async () => {
    let valid = await trigger()
    if (!valid) return
    handleClose()
    onConfirm && onConfirm(getValues())
  }
  return (
    <SkywatchDialog
      open={open}
      closeDialog={handleClose}
      maxWidth={'xs'}
      circleHeader={
        <ElevatedCircle>
          {' '}
          <AlternateEmailIcon className="blue" />{' '}
        </ElevatedCircle>
      }
      closeTitle={title}>
      <FlexView column>
        <div className="text-title blue bold margin-top-basic textcenter margin-bottom-basic">
          {title}
        </div>
        <div className="text-body black margin-top-basic margin-bottom-basic">
          {body}
        </div>
        <TextField
          error={!!errors.email}
          helperText={!!errors.email && 'Invalid email address'}
          autoComplete="email"
          type="email"
          label="Email Address"
          fullWidth
          variant="outlined"
          autoFocus
          name="email"
          inputRef={register({
            required: true,
            pattern: EMAIL_REGEX,
            message: 'Invalid email address',
          })}
        />
        <div style={{ display: props.showDuration ? undefined : 'none' }}>
          <div className="text-body black margin-top-basic">
            Select duration
          </div>
          <Controller
            control={control}
            name="action"
            defaultValue={props.duration || 'annualBind'}
            as={
              <RadioGroup>
                <FlexView>
                  {FirebaseService.getBoolean(
                    FirebaseConfigKey.ANNUAL_AVAILABLE
                  ) && (
                    <FormControlLabel
                      label="Annual"
                      value="annualBind"
                      control={<Radio color="primary" />}
                    />
                  )}
                  {FirebaseService.getBoolean(
                    FirebaseConfigKey.MONTHLY_AVAILABLE
                  ) && (
                    <FormControlLabel
                      label="Monthly"
                      value="monthlyBind"
                      control={<Radio color="primary" />}
                    />
                  )}
                </FlexView>
              </RadioGroup>
            }
          />
        </div>
        <div>
          <div className="text-body black margin-top-basic">Select type</div>
          <Controller
            control={control}
            name="insuranceType"
            defaultValue={'Personal'}
            as={
              <RadioGroup>
                <FlexView>
                  {
                    <FormControlLabel
                      label="Personal"
                      value="Personal"
                      control={<Radio color="primary" />}
                    />
                  }
                  {
                    <FormControlLabel
                      label="CFI"
                      value="CFI"
                      control={<Radio color="primary" />}
                    />
                  }
                </FlexView>
              </RadioGroup>
            }
          />
        </div>
        <NewFillButton onClick={Confirm}>OK</NewFillButton>
        <div
          onClick={handleClose}
          className="margin-bottom-basic text-body textcenter gray underline clickable">
          Close
        </div>
      </FlexView>
    </SkywatchDialog>
    /*{<Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
         <DialogTitle id="form-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {body}
          </DialogContentText>
          <TextField 
            error={!!errors.email} 
            helperText={!!errors.email && 'Invalid email address'}
            autoComplete="email"
            type="email" 
            label="Email Address" 
            fullWidth
            autoFocus
            margin="dense"
            name="email" 
            inputRef={register({required: true, pattern: EMAIL_REGEX })}  />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={Confirm} color="primary">
            ok
          </Button>
        </DialogActions>
      </Dialog> }*/
  )
}
